module.exports = __webpack_public_path__ + "static/media/48-iveco-mercedes.5d9e4998.jpg";